// extracted by mini-css-extract-plugin
module.exports = {"Notification":"Notification_Notification__2vzo1"};